import { BaseRecord } from "./BaseRecord";

export class RecentOrderItem {
    orderId: number = 0;
    orderNo: number = 0;
    tenantName: string = '';
    orderStatus: string = '';  // API returns string enum e.g. "OrderPlaced"
    orderStatusLabel: string = '';
    totalQty: number | null = null;
    totalWeight: number | null = null;
    createdOn: Date = new Date();
}

export class CustomerDashboardCounter extends BaseRecord<number> {
    public totalB2BClient!: number;
    public totalB2CClient!: number;
    public totalCategory!: number;
    public totalDie!: number;
    public totalOrders!: number;
    public totalOrdersPending!: number;
    public totalOrdersInProduction!: number;
    public totalOrdersCompleted!: number;
    public recentOrders: RecentOrderItem[] = [];

    constructor() {
        super();
        this.totalB2BClient = 0;
        this.totalB2CClient = 0;
        this.totalCategory = 0;
        this.totalDie = 0;
        this.totalOrders = 0;
        this.totalOrdersPending = 0;
        this.totalOrdersInProduction = 0;
        this.totalOrdersCompleted = 0;
        this.recentOrders = [];
    }
}